var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7067 11.98H4.29337C1.64004 11.98 0.833374 11.1733 0.833374 8.52001V4.29334C0.833374 1.64001 1.64004 0.833344 4.29337 0.833344H11.7C14.3534 0.833344 15.16 1.64001 15.16 4.29334V8.51334C15.1667 11.1733 14.36 11.98 11.7067 11.98ZM4.29337 1.83334C2.20004 1.83334 1.83337 2.20001 1.83337 4.29334V8.51334C1.83337 10.6067 2.20004 10.9733 4.29337 10.9733H11.7C13.7934 10.9733 14.16 10.6067 14.16 8.51334V4.29334C14.16 2.20001 13.7934 1.83334 11.7 1.83334H4.29337Z",
    fill: "#BFC3CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.1667C7.72667 15.1667 7.5 14.94 7.5 14.6667V11.48C7.5 11.2067 7.72667 10.98 8 10.98C8.27333 10.98 8.5 11.2067 8.5 11.48V14.6667C8.5 14.94 8.27333 15.1667 8 15.1667Z",
    fill: "#BFC3CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 9.16666H1.33337C1.06004 9.16666 0.833374 8.93999 0.833374 8.66666C0.833374 8.39332 1.06004 8.16666 1.33337 8.16666H14.6667C14.94 8.16666 15.1667 8.39332 15.1667 8.66666C15.1667 8.93999 14.94 9.16666 14.6667 9.16666Z",
    fill: "#BFC3CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.1667H5C4.72667 15.1667 4.5 14.94 4.5 14.6667C4.5 14.3933 4.72667 14.1667 5 14.1667H11C11.2733 14.1667 11.5 14.3933 11.5 14.6667C11.5 14.94 11.2733 15.1667 11 15.1667Z",
    fill: "#BFC3CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.43f5a698.svg";
export { ForwardRef as ReactComponent };